import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { t } from '@lingui/macro';
import Waypoint from 'react-waypoint';
import PropTypes from 'prop-types';
import '../../styles/core.scss';
import css from './library.scss';
import LibraryItem from '../../components/library-item/library-item';
import LibraryItemDetail from '../../components/library-item-detail/library-item-detail';
import { loadLibraryItems, libraryItemSelected, reloadFilteredItems,
    switchLibraryItemType, loadMoreRenderedItems } from './library-actions';
import ResultSummary from '../../components/result-summary/result-summary';
import ArrowButton from '../../components/arrow-button/arrow-button';
import BookCover from '../../components/book-cover/book-cover';
import Icon from '../../assets/images/icon_empty.svg';
import { NUMBER_OF_LOADING_ITEMS } from '../../config';

class Library extends Component {
    static propTypes = {
        libraryReducer: PropTypes.object,
        loadLibraryItems: PropTypes.func,
        libraryItemSelected: PropTypes.func,
        reloadFilteredItems: PropTypes.func,
        switchLibraryItemType: PropTypes.func,
        loadMoreRenderedItems: PropTypes.func,
        i18n: PropTypes.object
    };

    constructor(props) {
        super(props);
        this.libraryItemListDiv = null;
    }

    componentDidMount() {
        this.props.loadLibraryItems();
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.libraryReducer.filteredItems === undefined) {
            return true;
        }

        if (this.props.libraryReducer.filteredItems !== nextProps.libraryReducer.filteredItems) {
            if (this.libraryItemListDiv) {
                this.libraryItemListDiv.scrollTop = 0;
            }
            return true;
        }
        if (this.props.libraryReducer.selectedItemDetail !== nextProps.libraryReducer.selectedItemDetail) {
            return true;
        }
        if (this.props.libraryReducer.renderedItems !== nextProps.libraryReducer.renderedItems) {
            return true;
        }
        if (this.props.libraryReducer.resultSummaryText !== nextProps.libraryReducer.resultSummaryText) {
            return true;
        }

        const existingItemIds = _.map(this.props.libraryReducer.filteredItems, 'itemId');
        const newIds = _.map(nextProps.libraryReducer.filteredItems, 'itemId');

        const existingTypeIds = _.map(this.props.libraryReducer.filteredItems, 'itemTypeId');
        const newTypeIds = _.map(nextProps.libraryReducer.filteredItems, 'itemTypeId');

        return _.difference(existingItemIds, newIds).length > 0 || existingItemIds.length !== newIds.length || _.difference(existingTypeIds, newTypeIds).length > 0;
    }

    handleLibraryItemSelected = (contentUrl, itemType) => {
        this.props.libraryItemSelected(contentUrl, itemType);
    };

    handleBookSwitch = (selectedItemType) => {
        this.props.switchLibraryItemType(selectedItemType);
    };

    handleBackButtonClick = () => {
        this.props.reloadFilteredItems();
    };

    renderLibraryItems = items => (
        items.map(({ itemType, itemId, seriesName, title, thumbnailUrl, contentUrl }) => (
            <LibraryItem key={itemType + itemId} itemId={itemId} grade={seriesName} title={title} itemType={itemType} thumbnailUrl={thumbnailUrl} callbackOnClick={() => this.handleLibraryItemSelected(contentUrl, itemType)} />
        )
    ));

    getResultText = () => {
        const { resultSummaryText } = this.props.libraryReducer;
        const { i18n } = this.props.i18n;
        switch (resultSummaryText) {
            case 'Search results for Grade':
                return `${i18n._(t`Search results for Grade`)}`;
            case 'Search results for':
                return `${i18n._(t`Search results for`)}`;
            default:
                return `${i18n._(t`Showing all results`)}`;
        }
    };

    loadMore = () => (this.props.loadMoreRenderedItems(NUMBER_OF_LOADING_ITEMS));

    render() {
        const { i18n } = this.props.i18n;
        if (this.props.libraryReducer.filteredItems !== undefined && this.props.libraryReducer.selectedItemDetail === null) {
            return (
                            this.props.libraryReducer.filteredItems.length > 0
                                ?
                                (
                                    <div className={css.component}>
                                        <div>
                                            <div className={css.resultTitle}>
                                                <ResultSummary text={`${this.getResultText()} ${this.props.libraryReducer.concateSearchTerm || ''}`} count={this.props.libraryReducer.filteredItems.length} />
                                            </div>
                                            <div className={css.itemsWrapper} ref={(div) => { this.libraryItemListDiv = div; }}>
                                                {this.props.libraryReducer.renderedItems ? this.renderLibraryItems(this.props.libraryReducer.renderedItems) : null}
                                                <Waypoint onEnter={this.loadMore} />
                                            </div>
                                        </div>
                                    </div>
                                )
                                :
                                (
                                    <div className={css.emptyContainer}>
                                        <div className={css.emptyNotice}>
                                            <div className={css.emptyState}>
                                                <img src={Icon} width="100" height="100" alt="" />
                                            </div>
                                            <div className={css.noResult}>{i18n.t`No results found`}</div>
                                        </div>
                                    </div>
                                )
            );
        }


        if (this.props.libraryReducer.selectedItemDetail !== undefined && this.props.libraryReducer.selectedItemDetail !== null) {
            return (
                <div className={css.component}>
                    <div className={css.itemDetails}>
                        <div className={css.backButton}><ArrowButton c arrowText="&lt;" onButtonClick={this.handleBackButtonClick} /></div>
                        <div className={css.bookCover}>
                            <div className={css.itemsCover}>
                                {
                                    this.props.libraryReducer.selectedItemDetail.items.map(({ id, type, coverImageUrl, title }) =>
                                        <BookCover key={id + type} imageUrl={coverImageUrl} title={title} type={type} isSelected={type === this.props.libraryReducer.selectedItemDetail.selectedItem.type} onBookSwitch={() => this.handleBookSwitch(type)} />
                                    )
                                }
                            </div>
                            <div className={css.itemDetail}>
                                <LibraryItemDetail item={this.props.libraryReducer.selectedItemDetail.selectedItem} />
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        return (<div className={css.component} />);
    }
}

function mapStateToProps(state = {}) {
    return {
        ...state,
        libraryReducer: state.libraryReducer
    };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
     loadLibraryItems,
     libraryItemSelected,
     reloadFilteredItems,
     switchLibraryItemType,
     loadMoreRenderedItems
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Library);
